import { AnchoredPanel, BookmarkablePage, useNavigation } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { ConsoleContext } from "../../console/ConsoleContext";
import { MCVCN_LIST_ROUTE, PageId, PageRegistrationConfig } from "../../constants/pluginConstants";
import { SvgIconIds } from "../../constants/uiConstants";
import { McvcnList } from "./McvcnList";

const registrationIds = PageRegistrationConfig[PageId.MCVCN_LIST].map(config => config.key);

export const McvcnListPage = (): JSX.Element => {
  const { back, navigateToSelf } = useNavigation(ConsoleContext);

  React.useEffect(() => {
    // In case page was navigated to directly by entring its URL in the browser
    navigateToSelf(MCVCN_LIST_ROUTE, registrationIds[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BookmarkablePage
      appContext={ConsoleContext}
      registrationIds={registrationIds}
      title={Messages.listMcvcn.titles.short()}
    >
      <AnchoredPanel
        anchorId="page"
        title={Messages.listMcvcn.titles.long()}
        icon={SvgIconIds.networkSvg}
        onClose={back}
        isOpen
      >
        <McvcnList />
      </AnchoredPanel>
    </BookmarkablePage>
  );
};
